/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageProductShopsPageResponse } from '../../models/page-product-shops-page-response';

export interface GetShopsByPackagingUnitId$Params {

/**
 * Specified packagingUnitId
 */
  packagingUnitId: string;

/**
 * Filter on minimum price
 */
  minPrice?: number;

/**
 * Filter on maximum price
 */
  maxPrice?: number;

/**
 * Filter on possible payment methods
 */
  paymentMethods?: Array<'CASH' | 'CARD' | 'BANK_TRANSFER' | 'CASH_ON_DELIVERY'>;

/**
 * Filter on deliveryServiceAvailable
 */
  deliveryServiceAvailable?: boolean;

/**
 * Filter on onSiteServiceAvailable
 */
  onSiteServiceAvailable?: boolean;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getShopsByPackagingUnitId(http: HttpClient, rootUrl: string, params: GetShopsByPackagingUnitId$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductShopsPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getShopsByPackagingUnitId.PATH, 'get');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
    rb.query('minPrice', params.minPrice, {});
    rb.query('maxPrice', params.maxPrice, {});
    rb.query('paymentMethods', params.paymentMethods, {});
    rb.query('deliveryServiceAvailable', params.deliveryServiceAvailable, {});
    rb.query('onSiteServiceAvailable', params.onSiteServiceAvailable, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageProductShopsPageResponse>;
    })
  );
}

getShopsByPackagingUnitId.PATH = '/search/products/{packagingUnitId}/shops';
